// extracted by mini-css-extract-plugin
export default {"card":"ChangePassword_card__XRzAT"};